"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _reselect = require("reselect");
var _AdvancedOrderFormComponent = _interopRequireDefault(require("./AdvancedOrderFormComponent"));
var _orderEntryActions = require("../../../redux/actions/orderEntryActions");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _orderFormTypes = require("../../../constants/sendOrder/orderFormTypes");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
var _selectors = require("../../../redux/margin/selectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _userSelectors = require("../../../redux/selectors/userSelectors");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _marginInstrumentSelectors = require("../../../redux/margin/selectors/marginInstrumentSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ORDER_FORM_NAME = 'advancedOrderEntry';
var selectorArgs = {
  formName: ORDER_FORM_NAME
};
var makeSelectOrderInitialValues = function makeSelectOrderInitialValues() {
  return (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentIdSelector, function (state) {
    return (0, _orderEntrySelector.selectOrderSide)(state, selectorArgs);
  }], function (instrumentId, side) {
    return {
      instrument: instrumentId,
      orderType: _orderEntryFormConstants.advancedOrderFormTypes.limit.displayName,
      quantity: '',
      value: '',
      trailingAmount: '',
      limitPrice: '',
      stopPrice: '',
      fee: '0',
      totalAmount: '0',
      limitOffset: '',
      pegPriceType: '1',
      price: '',
      timeInForce: '1',
      anchoredField: '',
      side: side !== null && side !== void 0 ? side : _orderEntryFormConstants.buyValue
    };
  });
};
var mapDispatchToProps = {
  clearAdvancedOrderEntryForm: function clearAdvancedOrderEntryForm() {
    return (0, _orderEntryActions.clearBuySellForm)(ORDER_FORM_NAME);
  },
  synchronizeQuantityWithPrice: _orderEntryActions.synchronizeQuantityWithPrice,
  synchronizePriceWithQuantity: _orderEntryActions.synchronizePriceWithQuantity,
  reduxFormChange: function reduxFormChange(key, val) {
    return (0, _reduxForm.change)(ORDER_FORM_NAME, key, val);
  },
  closeSidePane: _sidePaneActions.closeAdvancedOrderSidePane
};
var makeMapStateToProps = function makeMapStateToProps() {
  var selectInitialValues = makeSelectOrderInitialValues();
  return function (state) {
    var _selectOrderSide;
    var side = (_selectOrderSide = (0, _orderEntrySelector.selectOrderSide)(state, selectorArgs)) !== null && _selectOrderSide !== void 0 ? _selectOrderSide : _orderEntryFormConstants.buyValue;
    var isMarginActive = (0, _selectors.isMarginActiveSelector)(state);
    var instruments = isMarginActive ? (0, _marginInstrumentSelectors.instrumentSelectorMarginInstruments)(state) : (0, _instrumentPositionSelectors.instrumentSelectorEnabledInstruments)(state);
    return {
      allowBlockTrading: (0, _userSelectors.isBlockTradingEnabledForUser)(state),
      side: side,
      isBuy: side === _orderEntryFormConstants.buyValue,
      orderTypes: (0, _orderEntrySelector.selectOrderTypes)(state, _orderEntryFormConstants.advancedOrderFormTypes),
      instruments: instruments,
      initialValues: selectInitialValues(state),
      disableTrading: (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state).disableTrading,
      isMarginActive: isMarginActive,
      maxQuantity: (0, _orderEntrySelector.selectOrderMaxQuantity)(state, selectorArgs)
    };
  };
};
var Form = (0, _reduxForm.reduxForm)({
  form: ORDER_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _orderEntryActions.placeOrderWithChecks)(_orderFormTypes.orderFormTypes.advanced, payload, ORDER_FORM_NAME));
  }
})(_AdvancedOrderFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(Form);